module.exports = __webpack_public_path__ + "static/media/190.5ff379ca.jpg";